<template>
  <v-dialog v-model="display" persistent max-width="600px" scrollable v-if="display">
    <v-form ref="procedureForm">
      <v-card min-height="200px">
        <v-card-title>
          <v-row>
            <v-col class="headline">
              Finalisation du dossier de demande d'agrément
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="text--primary">
          <v-row>
            <v-col>Cette demande d'agrément concerne:</v-col>
          </v-row>
          <v-container>
            <v-row>
              <v-col>établissement: {{ dossier.officine.denomination }}</v-col>
              <v-col>date de la demande: {{ getDate(dossier.dateDepot) }}</v-col>
            </v-row>
            <v-row>
              <v-col>demandeur: {{ dossier.demandeur }}</v-col>
              <v-col>type de la demande:
                {{
                    dossier.premiereDemande
                      ? "Première demande"
                      : "Renouvellement"
                }}</v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>Saisie de la décision :</v-col>
            </v-row>
            <v-container>
              <v-row>
                <v-col>
                  décision du Comité Régional d'Agréments (CRA) :
                </v-col>
                <v-col>
                  <v-radio-group v-model="dossier.decisionCRA" :rules="dossierRules">
                    <v-radio :value="true" label="demande validée"></v-radio>
                    <v-radio :value="false" label="demande rejetée"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  date de la commission :
                </v-col>
                <v-col>
                  <div>
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                      :return-value.sync="dateDecisionCRA" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field id="agree-calendar" v-model="formatedDateDecisonCRA" label="Date de la commission"
                          prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" required :rules="textRules">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="dateDecisionCRA" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Annuler
                        </v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(dateDecisionCRA)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="dossier.decisionCRA !== true">
                <v-col>
                  <v-checkbox v-model="motif[0].model" :label="motif[0].value" :value="motif[0].value" class="pa-1 mt-0"
                    hide-details>
                  </v-checkbox>
                  <v-checkbox v-model="motif[1].model" :label="motif[1].value" :value="motif[1].value" class="pa-1 mt-0"
                    hide-details>
                  </v-checkbox>
                  <v-checkbox v-model="motif[2].model" :label="motif[2].value" :value="motif[2].value" class="pa-1 mt-0"
                    hide-details>
                  </v-checkbox>
                  <v-checkbox v-model="motif[3].model" :label="motif[3].value" :value="motif[3].value" class="pa-1 mt-0"
                    hide-details>
                  </v-checkbox>
                  <v-checkbox v-model="motif[4].model" :label="motif[4].value" :value="motif[4].value" class="pa-1 mt-0"
                    hide-details>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-textarea v-model="dossier.commentaireDecisionCRA" label="commentaire :" class="pa-1 mt-0"
                    hide-details>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <p v-if="!formValid" class="text-caption red--text">
            Un ou plusieurs champs sont mal renseignés
          </p>
          <v-spacer></v-spacer>
          <div v-if="null !== dossier.decisionCRA">
            <v-btn small class="white--text" @click="sendAction()" :color="dossier.decisionCRA ? 'success' : 'error'">
              {{
                  dossier.decisionCRA
                    ? "Finaliser la validation de la demande d'agrément"
                    : "Finaliser le rejet de la demande d'agrément"
              }}
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-btn small class="white--text" @click="displayed = false" color="primary">
              Annuler
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import common from "@/common";
import moment from "moment";

export default {
  name: "ModalFinalisation",
  props: ["dossier", "display"],
  data() {
    return {
      dateDecisionCRA: null,
      motif: [
        {
          model: null,
          value:
            "la structure d’accueil pour les stagiaires et notamment la mise en œuvre des entretiens pharmaceutiques, ne permet pas d’accompagner nos stagiaires dans leur formation aux nouvelles missions du pharmacien"
        },
        {
          model: null,
          value:
            "la structure d’accueil pour les stagiaires et notamment l’organisation du préparatoire, outil indispensable pour la réalisation des stages, ne répond pas aux bonnes pratiques des préparations"
        },
        {
          model: null,
          value:
            "la structure d’accueil pour les stagiaires n’est pas engagée dans une démarche qualité, outils nécessaires à la sécurisation des actes pharmaceutiques"
        },
        {
          model: null,
          value:
            "la structure d’accueil pour les stagiaires ne permet pas de satisfaire aux conditions d’accueil adéquates à la formation des stagiaires"
        },
        { model: null, value: "Autre (précisez dans le commentaire libre)" }
      ],
      formValid: true,
      dossierRules: [v => v !== null || "Vous devez rendre une décision."]
    };
  },
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    },
    formatedDateDecisonCRA() {
      return this.dateDecisionCRA
        ? moment(this.dateDecisionCRA).format("DD/MM/YYYY")
        : "";
    }
  },
  methods: {
    sendAction() {
      if (this.$refs.procedureForm.validate()) {
        this.formValid = true;
        this.dossier.motifDecisionCRA = null;
        this.dossier.dateDecisionCRA = this.dateDecisionCRA;
        if (null !== this.motif && Array.isArray(this.motif)) {
          for (const m of this.motif) {
            if (m.model) {
              if (this.dossier.motifDecisionCRA)
                this.dossier.motifDecisionCRA += m.value + "\n";
              else this.dossier.motifDecisionCRA = m.value + "\n";
            }
          }
        }
        this.$emit("ModalFinalisationAction", this.dossier);
        this.displayed = false;
      } else {
        this.formValid = false;
      }
    },
    getDate(timestamp) {
      return common.formatDate(timestamp);
    }
  },
  created() {
    if (this.dossier.dateDecisionCRA) {
      let unix_timestamp = this.dossier.dateDecisionCRA;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateDecisionCRA = year + "-" + month + "-" + day;
    }
  }
};
</script>
